import { render, staticRenderFns } from "./ConceptLook.vue?vue&type=template&id=08165e9b&scoped=true&"
import script from "./ConceptLook.vue?vue&type=script&lang=js&"
export * from "./ConceptLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08165e9b",
  null
  
)

export default component.exports